module.exports = __webpack_public_path__ + "img/collection.e99f6239.png";